import { TextField } from '@mui/material';
import { useField } from 'formik';

import HelperText from './HelperText';

export default function NumberField({ name, dontAllowZero = false, margin = 'normal', required = false, helperText, onChange, onBlur, label, ...rest }) {
    const [field, meta, helper] = useField(name);

    const handleChange = event => {
        const value = parseFloat(event.target.value);

        if (isNaN(value)) {
            helper.setValue(null);

            return;
        }

        if ((dontAllowZero && value > 0) || (!dontAllowZero && value >= 0)) {
            if (onChange) onChange(value, field, helper);
            helper.setValue(value);
        }
    };

    const handleBlur = event => {
        if (onBlur) onBlur(event, field, helper);
        field.onBlur(event);
    };

    return (
        <TextField
            {...rest}
            data-cy={label}
            fullWidth
            type="number"
            label={label}
            inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
            InputProps={{ className: 'field' }}
            value={field.value ?? ''}
            error={!!meta.error}
            margin={margin}
            required={required}
            onChange={handleChange}
            onBlur={handleBlur}
            helperText={<HelperText meta={meta} required={required} helperText={helperText} />}
        />
    );
}
